import * as angular from 'angular';
import 'angular-modal-service';
import 'angular-ui-router';
import shared from 'modules/shared';
import permissions from 'application/detail/permissions.json';
import { WelcomeController } from './welcome/WelcomeController';
import { WelcomeService } from './welcome/WelcomeService';
import WelcomeView from './welcome/WelcomeView.html';
import { PersistentMenuController } from './persistentMenu/PersistentMenuController';
import { PersistentMenuService } from './persistentMenu/PersistentMenuService';
import PersistentMenuView from './persistentMenu/PersistentMenuView.html';
import EditApplicationView from './basic/EditApplicationView.html';
import { EditApplicationController } from './basic/EditApplicationController';
import ConfigMenuView from './ConfigMenuView.html';
import { ConfigMenuController } from './ConfigMenuController';
import ApiView from './api/ApiView.html';
import { ApiController } from './api/ApiController';
import KeysView from './keys/KeysView.html';
import { KeysController } from './keys/KeysController';
import MimeTypesView from './mimetypes/MimeTypesView.html';
import { MimeTypeController } from './mimetypes/MimeTypesController';
import AdvancedConfigurationsView from './advanced/AdvancedConfigurationsView.html';
import { ContentAdvancedConfigurationComponent } from './advanced/contentAdvancedConfiguration';
import { AdvancedConfigurationsController } from './advanced/AdvancedConfigurationsController';
import { ProfileCommandProcessor } from './ProfileCommandProcessor';
import { FacebookProfileCommandProcessor } from './FacebookProfileCommandProcessor';
import { ConfigurationsSegmentService } from './ConfigurationsSegmentService';
import ui from 'modules/ui';
import chatbotEditor from 'modules/editors/chatbotEditor';
import nodeMessageReceiver from 'modules/editors/nodes/nodeMessageReceiver';
//
export const configurations = angular
    .module('configurations', [
    'ui.router',
    'angularModalService',
    shared,
    ui,
])
    .service('ProfileCommandProcessor', ProfileCommandProcessor)
    .service('FacebookProfileCommandProcessor', FacebookProfileCommandProcessor)
    .service('WelcomeService', WelcomeService)
    .service('PersistentMenuService', PersistentMenuService)
    .service('ConfigurationsSegmentService', ConfigurationsSegmentService)
    .component('contentAdvancedConfiguration', ContentAdvancedConfigurationComponent)
    .component('chatbotEditor', chatbotEditor)
    .component('nodeMessageReceiver', nodeMessageReceiver)
    .controller('EditApplicationController', EditApplicationController)
    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('auth.application.detail.configurations', {
            url: '/configurations',
            redirectTo: 'auth.application.detail.configurations.basic',
            views: {
                'sidenav@auth.application.detail': {
                    template: ConfigMenuView,
                    controller: ConfigMenuController,
                    controllerAs: '$ctrl',
                },
            },
            data: {
                permissionClaim: permissions.basicConfigurations.claim,
            },
        })
            .state('auth.application.detail.configurations.basic', {
            url: '/basic',
            views: {
                'content@auth.application.detail': {
                    template: EditApplicationView,
                    controller: EditApplicationController,
                    controllerAs: '$ctrl',
                },
            },
            data: {
                permissionClaim: permissions.basicConfigurations.claim,
            },
            params: {
                area: 'basicConfigurations',
            },
        })
            .state('auth.application.detail.configurations.advanced', {
            url: '/advanced',
            views: {
                'content@auth.application.detail': {
                    template: AdvancedConfigurationsView,
                    controller: AdvancedConfigurationsController,
                    controllerAs: '$ctrl',
                },
            },
            data: {
                permissionClaim: permissions.basicConfigurations.claim,
            },
            params: {
                area: 'basicConfigurations',
            },
        })
            .state('auth.application.detail.configurations.welcome', {
            url: '/welcome',
            views: {
                'content@auth.application.detail': {
                    template: WelcomeView,
                    controller: WelcomeController,
                    controllerAs: '$ctrl',
                },
            },
            data: {
                permissionClaim: permissions.basicConfigurations.claim,
            },
            params: { area: 'basicConfigurations' },
        })
            .state('auth.application.detail.configurations.persistentMenu', {
            url: '/persistentMenu',
            views: {
                'content@auth.application.detail': {
                    template: PersistentMenuView,
                    controller: PersistentMenuController,
                    controllerAs: '$ctrl',
                },
            },
            data: {
                permissionClaim: permissions.basicConfigurations.claim,
            },
            params: { area: 'basicConfigurations' },
        })
            .state('auth.application.detail.configurations.apikey', {
            url: '/apikey',
            views: {
                'content@auth.application.detail': {
                    template: ApiView,
                    controller: ApiController,
                    controllerAs: '$ctrl',
                },
            },
            data: {
                permissionClaim: permissions.connectionInformations.claim,
            },
            params: { area: 'connectionInformations' },
        })
            .state('auth.application.detail.configurations.accessToken', {
            url: '/keys',
            views: {
                'content@auth.application.detail': {
                    template: KeysView,
                    controller: KeysController,
                    controllerAs: '$ctrl',
                },
            },
            data: {
                permissionClaim: permissions.team.claim,
            },
            params: { area: 'team' },
        })
            .state('auth.application.detail.configurations.extensions', {
            url: '/mimetypes',
            views: {
                'content@auth.application.detail': {
                    template: MimeTypesView,
                    controller: MimeTypeController,
                    controllerAs: '$ctrl',
                },
            },
            data: {
                permissionClaim: permissions.team.claim,
            },
            params: { area: 'team' },
        });
    }]).name;
